import { makeStyles } from "@material-ui/core/styles";
import zIndex from "@material-ui/core/styles/zIndex";


export const mapStyles = makeStyles(theme => ({
    mapCenterButton: {
        color: "#626262",
        position: "absolute",
        bottom: 120,
        right: 10,
        zIndex: zIndex.appBar,
        backgroundColor: "#FDFDFD",
        display: "block",
        cursor: "pointer",
        width: "2.5rem",
        minWidth: "2.5rem",
        height: "2.5rem",
        font: "400 0.8333rem Arial",
        boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 4px -1px",
        borderRadius: 2,
        "&:hover": {
            backgroundColor: "#FDFDFD",
            color: "#000",
        },
    },
    //This is to shift the map center button along with other buttons when the drawer is opened.
    mapWrapper: {
        height: "100vh",
        width: "100%",
        position: "relative",
        backgroundColor: "#EDEDED",
    },
    loaderContainer: {
        display: "flex",
        position: "absolute",
        alignItems: "center",
        justifyContent: "center",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        borderRadius: "2.5rem",
        padding: "1rem 2.25rem",
        backgroundColor: theme.palette.common.white,
    },
    loader: {
        width: "2.25rem",
        height: "2.25rem",
        marginRight: "1rem",
    },
}));

export const MapSearchBarStyles = makeStyles({
    root: {
        position: "absolute",
        right: 10,
        top: 10,
        backgroundColor: "transparent",
        zIndex: zIndex.appBar,
    },
});
